import { memo, useCallback, useEffect, useRef, useState } from 'react'
import './TextToInput.css'
import { useKeyPress } from '../../utils/customHooks'
import { LEFT_CLICK } from '../../utils/constantes'

const TextToInput = memo(
  ({
    className = '',
    textValue,
    initValue = '',
    onPaste = () => {},
    onBlur = () => {},
    onClick,
    id,
    forceEditable = false,
    forceDisabled = false,
    bgColor,
    isNumeric = false,
    shouldUppercase = false,
    autoFocus = true,
    autoSelect = true,
  }) => {
    const [inputValue, setInputValue] = useState(initValue)

    const [isEditable, setIsEditable] = useState(false)
    const wrapperRef = useRef(null)
    const inputRef = useRef(null)

    useEffect(() => {
      setInputValue(initValue)
    }, [initValue, isEditable])

    useEffect(() => {
      if (forceEditable) {
        setIsEditable(true)
      }
    }, [forceEditable])

    const blur = useCallback(
      (nextValue) => {
        let valueToSave = nextValue
        if (isNumeric && !nextValue) {
          valueToSave = 0
        } else if (isNumeric) {
          if (typeof valueToSave === 'string' && valueToSave?.toLowerCase().includes('h')) {
            const [hours, minutes] = valueToSave.toLowerCase().split('h')
            valueToSave = parseFloat(hours) + parseFloat(minutes) / 60
          }
          const numValue = parseFloat(valueToSave)
          if (isNaN(numValue)) {
            valueToSave = 0
          } else {
            valueToSave = numValue
          }
        }
        setInputValue('')
        onBlur(valueToSave)
        setIsEditable(false)
      },
      [onBlur, isNumeric]
    )

    useKeyPress(isEditable && !forceDisabled ? ['Enter', 'NumpadEnter', 'Escape'] : [], () =>
      inputRef?.current?.blur()
    )

    const handleFocus = (event) => {
      if (autoSelect) {
        event.target.select()
      }
    }

    const handleOnClick = (e) => {
      if (!forceDisabled) {
        if (e.button === LEFT_CLICK && !isEditable) {
          setIsEditable(true)
          onClick && onClick()
        }
      }
    }

    useEffect(() => {
      if (isEditable && !forceDisabled && autoFocus) {
        inputRef?.current?.focus()
      }
    }, [isEditable, forceDisabled, autoFocus])

    const handleInputChange = (e) => {
      const nextValue = e.target.value.replace(/,/, '.')
      if (isNumeric) {
        const numValue = parseFloat(nextValue)
        if (isNaN(numValue)) {
          setInputValue('')
        } else {
          setInputValue(nextValue)
        }
      } else {
        if (shouldUppercase) {
          setInputValue(nextValue?.toUpperCase())
        } else {
          setInputValue(nextValue)
        }
      }
    }

    const bgColorStyle = { backgroundColor: bgColor ? bgColor : '' }
    let textToRender = textValue
    if (!textValue) {
      textToRender = initValue
    }
    const canEdit = isEditable && !forceDisabled
    return (
      <div
        ref={wrapperRef}
        className={`inputToText ${className} ${forceDisabled ? 'disabled' : ''}`}
        onClick={handleOnClick}
      >
        <input
          ref={inputRef}
          style={canEdit ? bgColorStyle : { display: 'none' }}
          id={id}
          className="textStyle"
          onFocus={handleFocus}
          onBlur={() => blur(inputValue)}
          onPaste={onPaste}
          value={inputValue}
          onChange={handleInputChange}
        />
        {!canEdit && <div className="textStyle">{textToRender}</div>}
      </div>
    )
  }
)
export default TextToInput
